import { useEffect, useRef } from "react"
import withStyles from "react-jss"
import useWindowSize from "../../utils/useWindowSize"
import { MAX_WIDTH } from "../../data/globalStyles"

const styles = {
  container: {
    position: "relative",
    boxSizing: "border-box",
    width: "100%",
    maxWidth: "100%",
    overflowX: "scroll",
    display: "inline-flex",
    border: "1px solid #333333",
    borderLeft: 0,
    borderRight: 0,
    padding: 0,
    margin: 0,
    whiteSpace: "nowrap",
    justifyContent: "center",
    [`@media only screen and (max-width: ${MAX_WIDTH})`]: {
      justifyContent: "flex-start",
      "&:before": {
        width: "0px!important",
      },
    },
    "&:before": {
      content: "''",
      flexShrink: 0,
      display: "inline-block",
      position: "sticky",
      left: 0,
      width: "60px",
      height: "43px",
      verticalAlign: "top",
      // background: "linear-gradient(-270deg, #000000 0%, rgba(0, 0, 0, 0) 100%)",
      background: "transparent",
    },
    "&:after": {
      content: "''",
      flexShrink: 0,
      display: "inline-block",
      position: "sticky",
      right: 0,
      width: "60px",
      height: "43px",
      verticalAlign: "top",
      background: "linear-gradient(270deg, #000000 0%, rgba(0, 0, 0, 0) 100%)",
    },
    // Disable Scrollbar
    scrollbarWidth: "none", // Firefox
    "&::-webkit-scrollbar": {
      background: "transparent",
      height: "0px",
    },
  },
  list: {
    display: "flex",
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    listStyleType: "none",
    whiteSpace: "nowrap",
    justifyContent: "center",
  },
  listItem: {
    boxSizing: "border-box",
    display: "inline-block",
    margin: 0,
    padding: 0,
  },
  link: {
    display: "inline-block",
    fontFamily: "WiredMono",
    fontWeight: 400,
    fontSize: "11px",
    textTransform: "uppercase",
    lineHeight: "13px",
    letterSpacing: "0.916667px",
    color: "#757575",
    margin: "16px 32px",
    textDecoration: "none",
    textAlign: "center",
    whiteSpace: "nowrap",
    [`@media only screen and (max-width: ${MAX_WIDTH})`]: {
      margin: "16px",
    },
  },
  highlight: {
    composes: "$link",
    color: "#FF0000",
    textDecoration: "underline",
  },
  inactive: {
    composes: "$link",
    color: "#202124",
    cursor: "default",
  },
}

const Navigation = ({ classes }) => {
  const ref = useRef(null)
  // const { width } = useWindowSize()

  // useEffect(() => {
  //   if (ref.current) {
  //     ref.current.scrollLeft = ref.current.scrollWidth
  //   }
  // }, [width])

  //* uncomment on tuesday when other stories go live *//
  const data = [
    {
      id: 1,
      text: "The Suspicion Machine",
      ariaLabel: "The Suspicion Machine",
      href: "https://www.wired.com/story/welfare-state-algorithms",
    },
    {
      id: 2,
      text: "The Fraud Hunters",
      ariaLabel: "The Fraud Hunters",
      href: "https://www.wired.com/story/welfare-algorithms-discrimination",
    },
    {
      id: 3,
      text: "The Welfare War",
      ariaLabel: "The Welfare War",
      href: "https://www.wired.com/story/algorithms-welfare-state-politics",
    },
    {
      id: 4,
      text: "The Dirty Secret",
      ariaLabel: "The Dirty Secret",
      href: "https://www.wired.com/story/welfare-fraud-industry",
    },
  ]

  return (
    <nav className={classes.container} ref={ref}>
      <ol className={classes.list}>
        {data.map((d, i) => (
          <li className={classes.listItem} key={i}>
            <a
              className={
                d.id === 1
                  ? classes.highlight
                  : d.status === "inactive"
                  ? classes.inactive
                  : classes.link
              }
              href={d.href}
              aria-label={d.ariaLabel}>
              {d.text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default withStyles(styles)(Navigation)
